







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { PrepArea } from '@/models'

/**
 * Form of an area of the catalog or of a preparation. It emits `save` with the area and a
 * `done` callback: the parent saves it and calls `done(true)` to close the modal
 */
@Component
export default class UpsertPrepAreaModal extends Vue {
  @Prop({ required: false }) area: PrepArea | null

  private form: PrepArea = { id: 0, name: '', description: '', sortOrder: 0, tasks: [] }
  private saving = false

  get isNew(): boolean {
    return !this.area || !this.area.id
  }

  resetForm() {
    this.saving = false
    this.form = this.area
      ? { ...this.area, description: this.area.description || '' }
      : { id: 0, name: '', description: '', sortOrder: 0, tasks: [] }
  }

  save() {
    if (!this.form.name.trim() || this.saving) return
    this.saving = true
    this.$emit('save', { ...this.form }, (saved: boolean) => {
      this.saving = false
      if (saved) this.$bvModal.hide('UpsertPrepAreaModal')
    })
  }
}
